import { render, staticRenderFns } from "./ShopProducts.vue?vue&type=template&id=ce385d5c&"
import script from "./ShopProducts.vue?vue&type=script&lang=ts&"
export * from "./ShopProducts.vue?vue&type=script&lang=ts&"
import style0 from "./ShopProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports